import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NoPermission from "../NoPermission";
import { canVisitModule, getPermissionName } from "../../utils/permission";

const ModuleGuard = ({ requiredPermission, children }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const permission = useSelector((state) => state.permission);

  if (!permission.initialized) return null;

  const hasIdentity = Boolean(permission.currentIdentity);
  const needSelectIdentity = permission.needSelectIdentity && !hasIdentity;
  const allowed = canVisitModule({
    identityType: permission.identityType,
    permissionCodes: permission.permissionCodes,
    requiredPermission,
  });

  React.useEffect(() => {
    dispatch.permission.setState({ pagePermissionDenied: hasIdentity ? !allowed : false });
  }, [allowed, dispatch, hasIdentity, location.pathname]);

  if (!permission.isUnionUser) {
    return <Navigate to="/view/no_access?scene=union_not_open" replace />;
  }

  if (needSelectIdentity) {
    return <Navigate to="/view/identity_select" replace />;
  }

  if (!hasIdentity) {
    return <Navigate to="/view/no_access?scene=identity_invalid" replace />;
  }

  if (!allowed) {
    return (
      <NoPermission
        description={`您没有${getPermissionName(requiredPermission)}模块的访问权限，请联系主账号管理员开通`}
      />
    );
  }

  return children;
};

export default ModuleGuard;
